import { TestingLabsQuery, useTestingLabsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

export type TestingLab = TestingLabsQuery['project']['testingLabs'][0]
type TestingLabsContext = Pick<
  ReturnType<typeof useTestingLabsQuery>,
  'refetch'
> & {
  fetching?: boolean
  testingLabs?: TestingLab[]
}

const { useContextFn, Provider } =
  createStrictContext<TestingLabsContext>('TestingLabsContext')

export const useTestingLabsContext = useContextFn

const TestingLabsProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    loading: fetching,
    refetch,
  } = useTestingLabsQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  return (
    <Provider
      value={{
        refetch,
        fetching,
        testingLabs: data?.project?.testingLabs,
      }}
    >
      {children}
    </Provider>
  )
}

export default TestingLabsProvider
